export function getRedirectUri (uri?: string) {
  return uri !== undefined ? `${window.location.origin}${uri}` : window.location.origin
}
